import { Injectable } from '@angular/core';
import {
  DeleteStepData,
  DeleteTreeNode,
  FlowDetails,
  OperationState,
} from './models';
import { FlowBuilderImplService } from './implement/flow-builderImpl.service';
import { Step } from '../../../../shared/models';

import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root',
  useClass: FlowBuilderImplService,
})
export abstract class FlowBuilderService {
  /**
   * Set the Flow Area to a HTML element
   *
   * @param area
   */
  abstract set setFlowArea(area: HTMLDivElement);

  abstract get getFlowToDraw(): Observable<FlowDetails[]>;

  abstract get getDeletedSteps(): DeleteTreeNode[];

  abstract get getVariables(): string[];

  abstract get getAllSteps(): string[];

  abstract get getAllStepsOnCanvas(): string[];

  abstract get getAllStepsInTrash(): string[];

  abstract get getAllStepsDetails(): any;

  abstract get getOperationState(): OperationState;

  abstract getStep(stepId): any;

  abstract buildFlow(flow: any, flowStatus?: any): any;

  abstract newFlow(): void

  abstract setNodeValid(node: any, valid: boolean): any;

  abstract checkNodeValid(node: string): boolean;

  abstract setNextStep(step: Step): Object;

  abstract deleteStep(deleteStep: DeleteStepData): void;

  abstract getChildrenCount(stepId: string): number;

  abstract clearSteps(steps: string[]): void;

  abstract resetFlow(): void;

  abstract cut(stepId: string, parentId: string): void;

  abstract copy(stepId: string, parentId: string): void;

  abstract paste(stepId: string, parentId: string): void;

  abstract checkLoop(stepId: string): boolean;

  abstract restoreStep(
    stepId: string,
    parentId: string,
    filter: string,
    restoreChildren: boolean
  ): void;

  abstract getCurrFlow(): any;

  abstract setCurrFlow(flow: any): any;

  abstract getFlow(): any;

  abstract getModalOpen(): boolean;

  abstract setModalOpen(status: boolean): void;

  abstract setUnexecutedStyles(): void;

  abstract setExecutedStyles(source: string, target: string): void;

  abstract setDefaultStyles(): void;

  abstract addStep(nodeId: string, step: Step): void;

  abstract canSave(): boolean;

  abstract stepNameGenerator(): string;
  abstract getLastStepNumber(): number;
  abstract get hasInvalidSteps(): {valid: boolean, steps: []};
}
